// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"ab1bbdb8","462":"a496fc50","524":"d31dee38","609":"9a699794","641":"f746cd30","787":"8127ce38","841":"c870a697","851":"a2e21a51"}[chunkId] + ".chunk.js";
};